const autocompleteFormActions = {
  accountable: 'Accountables',
  helperText: 'Maximum quantity of accountables:',
};

export default autocompleteFormActions;
